import React, { ReactElement } from 'react';
import { ToggleableEmailField } from '@sm/question-ui/respondent-survey';

function WeblinkConfirmationCheckbox(): ReactElement {
  return <ToggleableEmailField responses={[]} />;
}

export default WeblinkConfirmationCheckbox;
